<ng-template #copyright>
  <p class="copyright tag">{{ 'FOOTER.LINKS.ACCIONA' | translate }}</p>
</ng-template>

<section class="hidden s:block">
  <ng-template [ngTemplateOutlet]="copyright" />
</section>
<section class="links-container">
  <a acSecondaryLink negative [routerLink]="legalRoute">
    {{ 'FOOTER.LINKS.LEGAL' | translate }}
  </a>
  <a acSecondaryLink negative [routerLink]="privacyRoute">
    {{ 'FOOTER.LINKS.PRIVACY' | translate }}
  </a>
  <a acSecondaryLink negative [routerLink]="cookiesRoute">
    {{ 'FOOTER.LINKS.COOKIES' | translate }}
  </a>
  <a acSecondaryLink negative href="{{ ethical_channel }}" target="_blank" rel="noreferrer noopener">
    {{ 'FOOTER.LINKS.ETHICAL_CHANNEL' | translate }}
    <ac-icon name="external-link" size="small"></ac-icon>
  </a>
</section>
<section class="s:!hidden mt-2">
  <ng-template [ngTemplateOutlet]="copyright" />
</section>
